import { TextField } from '@mui/material';
import React from 'react';
import { Context } from '../../App';


export default function Exercice() {
    const { exercice, setExercice, exercices } = React.useContext(Context);

    return (
        <TextField 
        select
        value={exercice}
        onChange={(e) => {
            setExercice(parseInt(e.target.value));
            sessionStorage.setItem('exercice', e.target.value);
        }}
        SelectProps={{ native: true, IconComponent: () => <></> }}
        size="small"
        sx={{minWidth:'150px'}}
        >
            <option value='' disabled>Select Exercice</option>
            {exercices.map((exercice) => (
                <option key={exercice} value={exercice}>
                    Exercice {exercice}
                </option>
            ))}
        </TextField>
    );
}